import { QueryClient } from '@tanstack/react-query'
import { createTRPCClient, httpBatchLink, TRPCClientError } from '@trpc/client'
import { createTRPCContext } from '@trpc/tanstack-react-query'
// Só o TIPO atravessa: nenhum código do servidor entra no bundle.
import type { AppRouter } from '@via-tax/api'

export const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<AppRouter>()

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      // Erro de autorização não melhora repetindo.
      retry: (falhas, erro) =>
        !(erro instanceof TRPCClientError && ['UNAUTHORIZED', 'FORBIDDEN', 'PRECONDITION_FAILED'].includes(erro.data?.code)) &&
        falhas < 2,
    },
  },
})

export const trpcClient = createTRPCClient<AppRouter>({
  links: [httpBatchLink({ url: '/trpc', fetch: (u, o) => fetch(u, { ...o, credentials: 'include' }) })],
})

export function mensagemDeErro(err: unknown): string {
  if (err instanceof TRPCClientError) {
    // Erro de validação do Zod chega como JSON; mostra só a primeira mensagem legível.
    try {
      const issues = JSON.parse(err.message) as Array<{ message?: string }>
      if (Array.isArray(issues) && issues[0]?.message) return issues[0].message
    } catch {
      /* mensagem já é texto */
    }
    return err.message
  }
  return err instanceof Error ? err.message : 'Erro inesperado'
}
